import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './RequestPasswordReset.css';

function RequestPasswordReset() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/auth/request-password-reset`, { email });
      setSubmitted(true);
    } catch (error) {
      console.error('Reset request error:', error);
      setSubmitted(true); // Show success anyway for security
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="auth-page">
        <div className="auth-card--wide">
          <div className="auth-emoji">📧</div>
          <h2>Check Your Email</h2>
          <p className="auth-success-msg">
            If an account exists with that email, we've sent password reset instructions.
          </p>
          <button
            onClick={() => navigate('/login')}
            className="auth-btn-success"
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Reset Password</h2>
        <p className="auth-subtitle">
          Enter your email and we'll send you a reset link.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label className="auth-label">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="auth-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="auth-btn-primary"
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>

          <button
            type="button"
            onClick={() => navigate('/login')}
            className="auth-btn-secondary"
          >
            Back to Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default RequestPasswordReset;
